import React from 'react';
import { defaultImage } from 'page-components/region/constants';
import classNames from 'classnames';
import WeSkiWidget from './WeSkiWidget';

import styles from './styles.module.scss';

const WeSkiPage = ({ destinationId, focusImage }: { destinationId: string, focusImage?: string }) => (
  <div className="w-100">
    <div
      className={classNames(styles.wrapper)}
    >
      <div
        className={classNames(styles.overlay)}
        style={{ backgroundImage: `url(${focusImage || defaultImage})` }}
      />

      <div className={classNames(styles.widget)}>
        <WeSkiWidget destinationId={destinationId} withTopCopy />
      </div>

    </div>
  </div>
);
export default WeSkiPage;
